module.exports = __webpack_public_path__ + "img/grey.b8c3b47.svg";